"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordModal = void 0;
const utils_1 = require("../../utils/utils");
const modal_1 = require("../../components/modal/modal");
const INPUT_SELECTOR = '[password-modal-input]';
class PasswordModal extends modal_1.ModalComponent {
    async show() {
        super.show();
        (0, utils_1.$el)(INPUT_SELECTOR, this)?.focus();
    }
}
exports.PasswordModal = PasswordModal;
